import { render } from "./CenterDesktopBar.vue?vue&type=template&id=4d693573&scoped=true"
import script from "./CenterDesktopBar.vue?vue&type=script&lang=js"
export * from "./CenterDesktopBar.vue?vue&type=script&lang=js"

import "./CenterDesktopBar.vue?vue&type=style&index=0&id=4d693573&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d693573"]])

export default __exports__